import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { TickIcon } from '@bnb-chain/icons';
import { Center, Flex, css, useColorMode } from '@chakra-ui/react';
import { useContext } from 'react';
import { theme } from '../../modules/theme';
import { Space } from '../Space';
import { Context } from './context';
export const SelectOption = ({ innerRef, innerProps, children, ...otherProps }) => {
    const { colorMode } = useColorMode();
    const { styles } = useContext(Context);
    return (_jsxs(Flex, { ref: innerRef, alignItems: "center", ...css(styles)(theme), borderRadius: 0, _hover: { backgroundColor: theme.colors[colorMode].layer[4].hover }, _active: { backgroundColor: theme.colors[colorMode].layer[4].hover }, ...(otherProps.isSelected
            ? {
                backgroundColor: theme.colors[colorMode].layer[4].hover,
            }
            : {
                backgroundColor: theme.colors[colorMode].layer[4].default,
            }), ...innerProps, children: [children, otherProps.isSelected && (_jsxs(_Fragment, { children: [_jsx(Space, { size: "fill" }), _jsx(Center, { p: theme.sizes['1'], children: _jsx(TickIcon, { fontSize: theme.sizes['4'] }) })] }))] }));
};
